import { render, staticRenderFns } from "./nameTable.vue?vue&type=template&id=b2a0c15a&scoped=true"
import script from "./nameTable.vue?vue&type=script&lang=js"
export * from "./nameTable.vue?vue&type=script&lang=js"
import style0 from "./nameTable.vue?vue&type=style&index=0&id=b2a0c15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0c15a",
  null
  
)

export default component.exports